<div class="pra-tat-page">
  <!-- Left: ZIP upload panel -->
  <section class="upload-panel">

    <div class="filter-upload-panel">
      <!-- Month -->
      <div class="filter-field">
        <label for="praTatMonth">Month</label>
        <select id="praTatMonth" [(ngModel)]="selectedMonth">
          <option value="">Select Month</option>
          <option *ngFor="let month of months" [value]="month.value">
            {{ month.label }}
          </option>
        </select>
      </div>

      <!-- Year -->
      <div class="filter-field">
        <label for="praTatYear">Year</label>
        <select id="praTatYear" [(ngModel)]="selectedYear">
          <option value="">Select Year</option>
          <option *ngFor="let year of years" [value]="year">
            {{ year }}
          </option>
        </select>
      </div>

      <!-- Upload ZIP -->
      <div class="filter-field upload-field">
        <label for="praTatZipFile">Upload ZIP</label>
        <label class="browse-button">
          <i class="fa fa-upload" aria-hidden="true"></i>
          {{ isUploading ? 'Uploading...' : 'Choose ZIP File' }}
          <input id="praTatZipFile"
                 type="file"
                 accept=".zip"
                 (change)="onFileSelected($event)"
                 [disabled]="isUploading || isValidating"
                 hidden />
        </label>
      </div>
    </div>

    <div class="message error-message" *ngIf="errorMessage" role="alert">
      {{ errorMessage }}
    </div>

    <div class="message success-message" *ngIf="successMessage" role="status">
      {{ successMessage }}
    </div>

  </section>

  <!-- Right: Uploaded File List -->
  <section class="list-panel">
    <div class="list-heading">
      <div>
        <h2>Uploaded Files</h2>
        <p>Review uploaded ZIP processing records.</p>
      </div>

      <button type="button"
              class="refresh-button"
              (click)="refreshList()"
              [disabled]="isLoadingList"
              title="Refresh list">
        <i class="fa fa-refresh"
           [class.fa-spin]="isLoadingList"
           aria-hidden="true"></i>
        Refresh
      </button>
    </div>

    <!-- Search Toolbar -->
    <div class="table-toolbar">
      <div class="search-box">
        <i class="fa fa-search" aria-hidden="true"></i>

        <input type="text"
               [(ngModel)]="searchText"
               placeholder="Search uploaded files..."
               aria-label="Search uploaded files" />
      </div>

      <span class="record-count">
        {{ filteredRecords.length }} records
      </span>
    </div>

    <!-- Records Grid -->
    <div class="table-wrapper">
      <table>
        <thead>
          <tr>
            <th>Id</th>
            <th>Entry Date</th>
            <th>Uploaded File</th>
            <th>WMS Excel</th>
            <th>Processed File</th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let record of paginatedRecords">
            <td>{{ record.Id }}</td>

            <td>
              {{
            record.EntryDate
              ? (record.EntryDate | date:'dd-MMM-yyyy')
              : '-'
              }}
            </td>

            <td>
              <span class="file-cell" [title]="record.UploadedFile || ''">
                <i class="fa fa-file-archive-o" aria-hidden="true"></i>
                <span>{{ record.UploadedFile || '-' }}</span>

                <button *ngIf="record.UploadedFile"
                        type="button"
                        class="download-button"
                        title="Download uploaded ZIP"
                        (click)="downloadFile(record, 'uploaded')">
                  <i class="fa fa-download" aria-hidden="true"></i>
                </button>
              </span>
            </td>

            <td>
              <span class="file-cell" [title]="record.WmsExcel || ''">
                <i class="fa fa-file-excel-o" aria-hidden="true"></i>
                <span>{{ record.WmsExcel || '-' }}</span>

                <button *ngIf="record.WmsExcel"
                        type="button"
                        class="download-button"
                        title="Download WMS Excel"
                        (click)="downloadFile(record, 'wms')">
                  <i class="fa fa-download" aria-hidden="true"></i>
                </button>
              </span>
            </td>

            <td>
              <span class="file-cell" [title]="record.ProcessedFile || record.ErrorMessage || ''">

                <!-- Show processed file when available -->
                <ng-container *ngIf="record.ProcessedFile; else showError">
                  <i class="fa fa-file-o" aria-hidden="true"></i>
                  <span>{{ record.ProcessedFile }}</span>

                  <button type="button"
                          class="download-button"
                          title="Download processed file"
                          (click)="downloadFile(record, 'processed')">
                    <i class="fa fa-download" aria-hidden="true"></i>
                  </button>
                </ng-container>

                <!-- Show error when processed file is unavailable -->
                <ng-template #showError>
                  <span *ngIf="record.ErrorMessage; else noFile"
                        class="error-message"
                        [title]="record.ErrorMessage">
                    <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                    {{ record.ErrorMessage }}
                  </span>

                  <ng-template #noFile>
                    <span>-</span>
                  </ng-template>
                </ng-template>

              </span>
            </td>
          </tr>

          <tr *ngIf="isLoadingList">
            <td colspan="5" class="empty-state">
              <span class="spinner"></span>
              Loading records...
            </td>
          </tr>

          <tr *ngIf="!isLoadingList && filteredRecords.length === 0">
            <td colspan="5" class="empty-state">
              <i class="fa fa-folder-open-o" aria-hidden="true"></i>
              {{
            searchText
              ? 'No matching records found.'
              : 'No uploaded files found.'
              }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <div class="pagination-bar">
      <div class="pagination-info">
        Showing
        <strong>{{ filteredRecords.length === 0 ? 0 : pageIndex * pageSize + 1 }}</strong>
        to
        <strong>{{ Math.min((pageIndex + 1) * pageSize, filteredRecords.length) }}</strong>
        of
        <strong>{{ filteredRecords.length }}</strong>
        records
      </div>

      <div class="pagination-controls">
        <label for="pageSize">Rows:</label>

        <select id="pageSize"
                [ngModel]="pageSize"
                (ngModelChange)="changePageSize($event)">
          <option [ngValue]="10">10</option>
          <option [ngValue]="25">25</option>
          <option [ngValue]="50">50</option>
          <option [ngValue]="100">100</option>
        </select>

        <button type="button"
                (click)="previousPage()"
                [disabled]="pageIndex === 0">
          <i class="fa fa-chevron-left" aria-hidden="true"></i>
          Previous
        </button>

        <span class="page-number">
          {{ pageIndex + 1 }} / {{ totalPages }}
        </span>

        <button type="button"
                (click)="nextPage()"
                [disabled]="pageIndex >= totalPages - 1">
          Next
          <i class="fa fa-chevron-right" aria-hidden="true"></i>
        </button>
      </div>
    </div>

  </section>
</div>
